import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormActions } from '../../components/form';
import { Search } from '../../components/search/Search.tsx';
import { SearchContextProvider } from '../../contexts/search.tsx';
import AlimentsHeader from './header.tsx';

const AlimentsPage = () => {
    const navigate = useNavigate();
    return (
        <SearchContextProvider>
            <AlimentsHeader />
            <Search disableRecipeSearch disableMealSearch />
            <FormActions
                mainAction={() => { navigate("/aliments/create"); }}
                mainActionText="Create"
            />
        </SearchContextProvider>
    );
};

export default AlimentsPage;
